module.exports = new __parcel__URL__("select-jetbrains-csv.72d553fd.svg").toString();